import update from 'immutability-helper';
import RequestSignatureConstants from './RequestSignatureConstants';

const initialState = {
  didAcceptTerms: false,
  isTermsOfServiceBannerVisible: false,
  isSignatureDeclineToolbarVisible: false,
};

const RequestSignatureReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }
  switch (action.type) {
    case RequestSignatureConstants.RECIPIENT_SIGNATURE_ENABLE:
      return update(state, {
        didAcceptTerms: { $set: true },
      });
    case RequestSignatureConstants.TERMS_OF_SERVICE_ERROR_SHOW:
      return update(state, {
        isTermsOfServiceBannerVisible: { $set: true },
      });
    case RequestSignatureConstants.SIGNATURE_DECLINE_TOOLBAR_SHOW:
      return update(state, {
        isSignatureDeclineToolbarVisible: { $set: true },
      });
    default:
      return state;
  }
};

export default RequestSignatureReducer;



// WEBPACK FOOTER //
// ./src-react/Popups/RequestSignaturePopupWrapper/RequestSignatureReducer.jsx